import { urls } from "../../data/urls";
import { Oauth2Apps } from "../../enums/Oauth2Apps";
import _ from "lodash";

export const getOauth2AppLogoUrl = (app: Oauth2Apps) => {
  return _.get(urls, ["assets", "oauth2Logos", app.toLowerCase()]);
};
